import { i18n } from '@/plugins/vuetify';
import { ApiError, errorI18nKey, isApiError } from './ApiError';

/**
 * Resuelve el texto a mostrar al usuario para un error de API.
 *
 * Precedencia: en un 400 se prefiere el mensaje del backend, que por contrato
 * es texto apto para el usuario y viene en el idioma de la sesión. Para errores
 * de infraestructura (413, 429, 403, 5xx) se usa la clave local, porque esos
 * mensajes suelen ser técnicos.
 *
 * @param error Error capturado; si no es un ApiError se devuelve el texto genérico.
 */
export const apiErrorText = (error: unknown): string => {
  const { t } = i18n.global;

  if (!isApiError(error)) return t('$vuetify.errores.generico');

  if (error.status === 400 && error.serverMessage) return error.serverMessage;

  if (error.code === 'RATE_LIMITED' && error.retryAfter) {
    return t(errorI18nKey(error), { seconds: error.retryAfter });
  }

  return t(errorI18nKey(error));
};

/** Pie del Swal con el código de referencia, solo si el backend lo envió. */
export const apiErrorFooter = (error: unknown): string | undefined => {
  if (!isApiError(error) || !error.correlationId) return undefined;
  return i18n.global.t('$vuetify.errores.referencia', {
    id: error.correlationId,
  });
};

export type { ApiError };
